module.exports = "/components/components/userEditableWages-3033de.html";